<template>
  <button
    :class="buttonClasses"
    :type="type"
    :disabled="disabled || loading"
    @click="handleClick"
  >
    <span hidden v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    <i v-if="icon && !loading" :class="iconClasses"></i>
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'ActionButton',
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    icon: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'button',
      validator: value => ['button', 'submit', 'reset'].includes(value)
    },
    block: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: '',
      validator: value => ['', 'sm', 'lg'].includes(value)
    }
  },
  computed: {
    buttonClasses() {
      const classes = ['btn'];

      if (this.outline) {
        classes.push(`btn-outline-${this.color}`);
      } else {
        classes.push(`btn-${this.color}`);

        // Only add text-white for solid buttons that aren't light/dark
        if (!this.color.includes('light') && !this.color.includes('dark')) {
          classes.push('text-white');
        }
      }

      if (this.block) {
        classes.push('btn-block');
      }

      if (this.size) {
        classes.push(`btn-${this.size}`);
      }

      return classes.join(' ');
    },
    iconClasses() {
      const classes = [];
      if (this.icon) {
        if (this.icon.startsWith('fa-')) {
          classes.push('fas', this.icon);
        } else {
          classes.push(this.icon);
        }
      }
      return classes.join(' ');
    }
  },
  methods: {
    handleClick(e) {
      if (!this.loading && !this.disabled) {
        this.$emit('click', e);
      }
    }
  }
};
</script>

<style scoped>
.btn {
  transition: all 0.2s ease;
  position: relative;
}

.btn:disabled {
  opacity: 0.65;
}

.spinner-border {
  margin-right: 0.5rem;
  vertical-align: middle;
}

.btn-block {
  width: 100%;
  display: block;
}

/* Special treatment for light buttons */
.btn-success-light {
  background-color: rgba(40, 167, 69, 0.1);
  color: #28a745;
  border-color: rgba(40, 167, 69, 0.2);
}

.btn-purple-light {
  background-color: rgba(102, 16, 242, 0.1);
  color: #6610f2;
  border-color: rgba(102, 16, 242, 0.2);
}

.btn-success-light:hover {
  background-color: rgba(40, 167, 69, 0.2);
  color: #28a745;
}

.btn-purple-light:hover {
  background-color: rgba(102, 16, 242, 0.2);
  color: #6610f2;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ActionButton.vue